module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SX-983991e25f2ced2e0de4bfc75ecaf1fd.png";